module.exports = __webpack_public_path__ + "img/Creste-Valoarea-nominala-uponline-1242x782.6ff023a3.png";